<script>
import {Tabs} from 'vant';
import SegmentedControl from '../../../shared/SegmentedControl.vue';
export default {
 name:'SegmentedTabs',inheritAttrs:false,
 props:{value:[String,Number],beforeChange:Function},
 methods:{async choose(value,title){if(value===this.value)return;if(this.beforeChange&&await this.beforeChange(value)===false)return;this.$emit('input',value);this.$nextTick(()=>this.$emit('change',value,title))}},
 render(h){const panes=(this.$slots.default||[]).filter(v=>v.componentOptions);return h('div',{class:'segmented-panels'},[
  h(SegmentedControl,panes.map((pane,index)=>{const p=pane.componentOptions.propsData||{},name=p.name??index;const title=pane.data?.scopedSlots?.title;return h('button',{key:name,attrs:{'aria-pressed':this.value===name,disabled:p.disabled},on:{click:()=>this.choose(name,p.title)}},title?title({}):[p.title])})),
  h(Tabs,{class:'segmented-panel-content',props:{...this.$attrs,active:this.value},on:{...this.$listeners,input:value=>this.$emit('input',value)}},this.$slots.default)
 ]);}
};
</script>
<style>
#app .segmented-panels>.segmented-panel-content>.van-tabs__wrap{display:none!important}
#app .segmented-panels{min-width:0;width:100%}
</style>
